// Components==============
import { faCamera } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import updateUser from 'actions/user/update';
import { useAlert } from 'hooks/useAlert';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React, { useRef } from 'react';
import Avatar from '../Avatar/Avatar';
import Button from '../Button/Button';
import './UploadProfileImage.module.scss';
// =========================

type Props = {
  isExtern?: boolean;
};

export default function UploadProfileImage({ isExtern }: Props) {
  const translate = useTranslate();
  const user = useRedux((state) => state.authentication?.user);

  const alert = useAlert();

  const dispatch = useReduxAction();

  const hasAvatar = user?.avatar_url && user.avatar_url?.length > 1;

  const ref = useRef<HTMLLabelElement>(null);

  function handleUpload(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file?.type.includes('image/')) {
      alert(translate('general.image-upload-alert'));
      return;
    }
    dispatch(updateUser({ id: user?.id, image: e.target.files?.[0] }));
  }

  return (
    <div styleName="wrapper">
      <input
        type="file"
        accept="image/*"
        id="btn"
        onChange={handleUpload}
        name="upload"
      />
      <label htmlFor="btn" ref={ref}>
        <div styleName="image-wrapper">
          <div styleName={`circle ${isExtern ? 'extern' : ''}`}>
            <img styleName="left" src="/images/groupwork-left.svg" alt="left" />
            <img
              styleName="right"
              src="/images/groupwork-right.svg"
              alt="right"
            />
            {hasAvatar ? (
              <Avatar size="big" />
            ) : (
              <div styleName="small-circle ">
                <FontAwesomeIcon icon={faCamera} />
              </div>
            )}
          </div>
          {!hasAvatar && !isExtern && (
            <div styleName="button">
              <Button onClick={() => ref.current?.click()}>
                {translate('project.groupswork-popups.image-popup.add-photo')}
              </Button>
            </div>
          )}
        </div>
      </label>
    </div>
  );
}
